export default {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};
